/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moving 4.6×150 mm, 5 µm → 2.1×50 mm, 2.6 µm lowers the flow and volumes.`)
};

const es_hplc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasar de 4.6×150 mm, 5 µm → 2.1×50 mm, 2.6 µm reduce el flujo y los volúmenes.`)
};

const de_hplc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Wechsel von 4,6×150 mm, 5 µm zu 2,1×50 mm, 2,6 µm senkt Fluss und Volumina.`)
};

const nl_hplc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overzetten van 4,6×150 mm, 5 µm → 2,1×50 mm, 2,6 µm verlaagt de flow en volumes.`)
};

const fr_hplc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer de 4,6×150 mm, 5 µm → 2,1×50 mm, 2,6 µm réduit le débit et les volumes.`)
};

const it_hplc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passando da 4,6×150 mm, 5 µm a 2,1×50 mm, 2,6 µm si riducono flusso e volumi.`)
};

const pt_br2_hplc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migrar de 4,6×150 mm, 5 µm → 2,1×50 mm, 2,6 µm reduz o fluxo e os volumes.`)
};

const pt_hplc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passar de 4,6×150 mm, 5 µm → 2,1×50 mm, 2,6 µm reduz o caudal e os volumes.`)
};

const ja_hplc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4.6×150mm、5µm → 2.1×50mm、2.6µmへの移行では、流速と体積が小さくなります。`)
};

const zh_hplc_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 4.6×150 mm、5 µm 转移到 2.1×50 mm、2.6 µm 会降低流速和体积。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_ex1", locale)
	if (locale === "en") return en_hplc_ex1(inputs)
	if (locale === "es") return es_hplc_ex1(inputs)
	if (locale === "de") return de_hplc_ex1(inputs)
	if (locale === "nl") return nl_hplc_ex1(inputs)
	if (locale === "fr") return fr_hplc_ex1(inputs)
	if (locale === "it") return it_hplc_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_ex1(inputs)
	if (locale === "pt") return pt_hplc_ex1(inputs)
	if (locale === "ja") return ja_hplc_ex1(inputs)
	return zh_hplc_ex1(inputs)
};